class menuNavigation extends HTMLElement {
    connectedCallback() {
        this.megamenu = document.querySelectorAll('mega-menu');
        this.genderTabs = this.querySelectorAll('.menu-tab');
        if (!this.genderTabs.length) {
            return;
        }
        this.init();
    }

    init() {
        this.redirectFlow();
        this.activeMenuVoiceGender();
        if (Shopify.designMode) return
    }

    redirectFlow() {

        this.megamenu[0].querySelectorAll('.menu-tab').forEach(tab => {
            tab.addEventListener('click', () => {
              localStorage.setItem("active_gender", tab.getAttribute('data-gender'));
            });
          });

        this.genderTabs.forEach(genderTab => {
            genderTab.addEventListener('click', this.handleClick.bind(this));
        });
    }

    handleClick(event) {
        const genderTab = event.target.closest('.menu-tab');
        if (!genderTab) return;
        this.writelocalStorage(genderTab);
    } 

    writelocalStorage(genderTab) {
        localStorage.setItem("active_gender", genderTab.getAttribute('data-gender'));
    }

    activeMenuVoiceGender() {
        const activeGender = localStorage.getItem("active_gender");

        if (!activeGender) {
            document.body.classList.add('gender-generic');
            return
        }

        document.body.classList.remove('gender-generic');

        //parent tab gender desktop
        this.megamenu[0].querySelectorAll('.menu-tab').forEach(singleTab => {
            if (singleTab.getAttribute('data-gender') === activeGender) {
                singleTab.classList.add('is-active');
            }
        });

        this.megamenu[1].querySelectorAll('.level2').forEach(singleTab => {
            if (singleTab.getAttribute('data-gender') === activeGender) {
                singleTab.classList.add('is-active');
            }
        });


        this.genderTabs.forEach(genderTab => {
            if ( genderTab.getAttribute('data-gender') !== activeGender ) return
            genderTab.setAttribute('open', '');
            genderTab.classList.add('menu-opening');
            const menuDrawerMenuItem = genderTab.querySelector('.menu-drawer__menu-item');
            menuDrawerMenuItem?.setAttribute('aria-expanded', true);
        });

    }
}

customElements.define('menu-navigation', menuNavigation);
